import { MORE_1024_MEDIA_QUERY } from '../../../../consts/adaptive';


export const styles = {
    container: {
        position: 'relative',
    },
    wrap: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    image: {
        display: 'block'
    },
    text: {
        color: '#999',
        fontSize: 16,
        transform: 'translateY(-12px)'
    },
    [MORE_1024_MEDIA_QUERY]: {
        container: {
            paddingRight: 0
        }
    }
};

export type ComponentJSSClasses = typeof styles;
